// ##############################################
// DO NOT CHANGE ANY OF THESE
// Doing so will cause DATA LOSS in the client!!!
// ##############################################
const SALT_BYTES_LENGTH = 32
const AES_KEY_ITERATIONS = 250000
// ##############################################

export const getSha256 = async (message: string): Promise<string> => {
  const encoder = new TextEncoder()
  const data = encoder.encode(message)
  const hashBuffer = await crypto.subtle.digest('SHA-256', data)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  return hashArray.map((num) => num.toString(16).padStart(2, '0')).join('')
}

export const generateSalt = (): Uint8Array => {
  return crypto.getRandomValues(new Uint8Array(SALT_BYTES_LENGTH))
}

export const stringToSalt = (str: string, length: number = SALT_BYTES_LENGTH): Uint8Array => {
  const encoder = new TextEncoder()
  const encoded = encoder.encode(str)

  if (encoded.length === length) {
    return encoded
  } else if (encoded.length > length) {
    return encoded.slice(0, length)
  } else {
    const padded = new Uint8Array(length)
    padded.set(encoded)
    return padded
  }
}

export const createPassKey = async (password: string): Promise<CryptoKey> => {
  const passwordBytes = new TextEncoder().encode(password)
  return crypto.subtle.importKey('raw', passwordBytes, 'PBKDF2', false, ['deriveKey'])
}

export const createAESKey = async (passKey: CryptoKey, salt: Uint8Array): Promise<Uint8Array> => {
  const derivedKey = await crypto.subtle.deriveKey(
    {
      name: 'PBKDF2',
      salt,
      iterations: AES_KEY_ITERATIONS,
      hash: { name: 'SHA-256' },
    },
    passKey,
    { name: 'AES-GCM', length: 256 },
    true,
    ['encrypt', 'decrypt']
  )

  return new Uint8Array(await crypto.subtle.exportKey('raw', derivedKey))
}
